import { useCurrencyContext } from '@components/Contexts/CurrencyContext';
import { ENABLE_TEMPLATE_PRICE_TAX_EXCLUSIVE_NOTE } from '@utils/constants';
import { useExperiments } from '@wix/fe-essentials-standalone';

const usePriceTaxExclusiveNotice = () => {
  const { experiments } = useExperiments({ readOnly: true });
  const isPriceNoticeExperimentOn = experiments.enabled(
    ENABLE_TEMPLATE_PRICE_TAX_EXCLUSIVE_NOTE,
  );

  const { isInPriceTaxInclusiveCountry } = useCurrencyContext();

  const isPriceTaxExclusiveNoticeShown =
    !isInPriceTaxInclusiveCountry && isPriceNoticeExperimentOn;

  return {
    isPriceTaxExclusiveNoticeShown,
  };
};

export default usePriceTaxExclusiveNotice;
